<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2022-2024, Vector Software BV                             **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Vector Software BV. Unauthorized copying or disclosure of this file,    **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
*****************************************************************************
-->

<template>
    <v-dialog
        v-model="startVectorDialog"
        persistent
        id="startVectorNotification"
        width="500px"
    >
        <v-card>
            <v-card-title>{{ language.t("Vector.StartVectorNotification.title") }}</v-card-title>
            <v-card-text>
                {{ language.t("Vector.StartVectorNotification.text") }}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    @click="$emit('close')"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="success"
                    @click="$emit('startVector');$emit('close')"
                >
                    <v-icon>mdi-check</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>

export default {
    components: {

    },
    props: {
        startVectorDialog: {
            required: true,
        }
    },
    data() {
        return {
            loading: false
        };
    },
    mounted: function () { },
    computed: {},
    watch: {
    },
    methods: {
    },
};
</script>
  
<style scoped></style>
  